import { useQuery } from "@tanstack/react-query";

import { quoteRequestProcessStepsQuery } from "#modules/quoteRequests/infra/quoteRequestProcessSteps.query";

export const useQuoteRequestProcessSteps = (id: string | undefined) => {
  const { data, ...rest } = useQuery({ ...quoteRequestProcessStepsQuery(id) });

  return { quoteRequestProcessSteps: data ?? [], ...rest };
};
